/* eslint-disable @typescript-eslint/no-explicit-any */
import { AxiosResponse } from "axios";
import { GetRequest } from "./RequestTemplates";

const isLocalEnvironment = () => {
  return window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
};

const mockAxiosResponse: AxiosResponse = {
  data: {
    id: "5b572710f057fc000112f079",
    country: "DE",
    displayName: "remind.me",
    name: {
      referring: ["remind.me", "www.remind.me"],
      identifying: "remind.me",
    },
    score: {
      stars: 4.5,
      trustScore: 4.5,
    },
    status: "active",
    websiteUrl: "http://remind.me",
    numberOfReviews: {
      total: 22249,
      usedForTrustScoreCalculation: 15343,
      oneStar: 1027,
      twoStars: 338,
      threeStars: 835,
      fourStars: 4302,
      fiveStars: 15747,
    },
    links: [],
    badFit: false,
  },
  status: 200,
  statusText: "OK",
  headers: {},
  config: {},
};

export const getTrustpilotData = async (): Promise<any> => {
  try {
    if (isLocalEnvironment()) {
      return Promise.resolve(mockAxiosResponse.data);
    }
    const res: AxiosResponse = await GetRequest(`${process.env.REMIND_ME_URL}/trustpilot.json`);
    return res.data;
  } catch (error) {
    console.error("Error fetching Trustpilot data:", error);
    return mockAxiosResponse.data;
  }
};

export const getTrustpilotReviews = async (): Promise<any> => {
  try {
    if (isLocalEnvironment()) {
      return Promise.resolve(mockAxiosResponse);
    }
    const res: AxiosResponse = await GetRequest(`${process.env.REMIND_ME_URL}/trustpilotReviews.json`);
    return res.data;
  } catch (error) {
    console.error("Error fetching Trustpilot reviews:", error);
    return mockAxiosResponse.data;
  }
};
